import React from "react";
import styles from "./About.module.css";

function About() {
    return (
        <div className={styles.wrapper}>
            <h2>About</h2>
            <p>
                Mallards are a very good duck. They are so pretty and they go
                quack very loud
            </p>
        </div>
    );
}

export default About;
